import { getGroupConfigSubdomain } from "@/configuration/paths";
import { ConfigSubdomain } from "@/configuration/tenant-ids";
import type { Group } from "@/src/models/group";
import type { Patient } from "@/src/models/patient";
import { getPersonReverseName } from "@/src/models/person";

/** Return null to use the shared copiable patient name (comma-separated reverse name). */
export function getPatientLookupCopiableNameOverride(
  group: Pick<Group, "subdomain"> | null,
  patient: Pick<Patient, "givenName" | "familyName">
): string | null {
  if (!group) {
    return null;
  }

  switch (getGroupConfigSubdomain(group)) {
    case ConfigSubdomain.CONFLUENT_ALL_STAR:
      return getPersonReverseName(patient, " ");
    default:
      return null;
  }
}
